import { rootSagaFactory } from '../importer/sagas';
import { EImportEntity } from '../importer/model';

import { ancillaryActivitiesImportDomainSelector } from './selectors';

export default rootSagaFactory({
  entity: EImportEntity.ANCILLARY_ACTIVITIES,
  domainSelector: ancillaryActivitiesImportDomainSelector,

  importApiCall: (backendApi, bookingManagerApi) => bookingManagerApi.postImportAncillaryActivities(),

  importStatusApiCall: async (backendApi, bookingManagerApi) => {
    const result = await bookingManagerApi.getImportAncillaryActivitiesStatus();

    // massage the result into the expected shape
    return {
      ...result,
      data: {
        ...result.data,
        meta: {
          workbookId: result.data.workbookId,
        },
        data: {
          ...result.data,
        },
      },
    };
  },
});
